module.exports = __webpack_public_path__ + "img/xsweblogo-07.319138d7.png";